import LogoWhite from "../assets/images/Logo_White.png";

const Images = {
  LogoWhite,
};

export default Images;
